export const TOGGLE_SIDE_PANEL = 'SIDE_PANEL/TOGGLE'
export const OPEN_SIDE_PANEL = 'SIDE_PANEL/OPEN'
export const CLOSE_SIDE_PANEL = 'SIDE_PANEL/CLOSE'
